import React, { PureComponent } from 'react'
import _ from 'lodash'
import { Icon, Button, Header, Form, Modal, Checkbox } from 'semantic-ui-react'
import firebase from '../../../config/firebase'

import BranchField from '../fields/branchField'
import ItemField from '../fields/itemField'

class crossSellItemForm extends PureComponent {
  btnSubmitRef = React.createRef()

  state = {
    selectedBranch: null,
    selectedItems: [],
    isApplyToAllBranches: false,
    loading: false,
  }

  componentDidMount() {
    const { action } = this.props

    if (action === 'edit') {
      this.getCrossSellData()
    }
  }

  getCrossSellData = () => {
    const { crossSellBranch } = this.props

    this.setState({
      selectedItems: crossSellBranch.item_ids,
      selectedBranch: crossSellBranch.branch_id,
    })
  }

  setStateAsync = state => new Promise(resolve => this.setState(state, resolve))

  onItemsChange = data => {
    const value = data.map(d => d.value)
    this.setState({ selectedItems: value })
  }

  saveToAllBranches = async () => {
    const { selectedItems } = this.state
    const { branches, merchantId } = this.props
    const batch = firebase.firestore().batch()

    _.forEach(branches, branch => {
      const doc = firebase.firestore().collection('cross_sell_items').doc()

      const updates = {
        branch_id: branch.key,
        merchant_id: merchantId,
        item_ids: selectedItems,
        created_at: Date.now(),
      }

      batch.set(doc, updates)
    })

    await batch.commit()
  }

  upsertToBranch = async () => {
    const { selectedBranch, selectedItems } = this.state
    const { crossSellBranch, merchantId, action } = this.props

    const { doc_id: docId } = crossSellBranch
    const crossSellRef = firebase.firestore().collection('cross_sell_items')

    await this.setStateAsync({ loading: true })

    const updates = {
      merchant_id: merchantId,
      branch_id: selectedBranch,
      item_ids: selectedItems,
      updated_at: Date.now(),
    }

    if (action === 'edit') {
      await crossSellRef.doc(docId).update(updates)
    } else {
      await crossSellRef.doc().set(updates)
    }
  }

  validateFields = () => {
    const { selectedItems, selectedBranch, isApplyToAllBranches } = this.state

    if (!isApplyToAllBranches && !selectedBranch) throw new Error('Please select Branch.')
    if (selectedItems.length === 0) throw new Error('Please select items.')

    return true
  }

  onSave = async e => {
    e.preventDefault()

    const { isApplyToAllBranches } = this.state
    const { onClose, merchantId, getCrossSellItems } = this.props

    try {
      this.validateFields()
      await this.setStateAsync({ loading: true })

      if (isApplyToAllBranches) {
        this.saveToAllBranches()
      } else {
        this.upsertToBranch()
      }

      await this.setStateAsync({ loading: false })
      getCrossSellItems(merchantId, false)
      onClose()

    } catch (error) {
      alert(error.message || error)
    }
  }

  render() {
    const { isApplyToAllBranches, loading, selectedBranch, selectedItems } = this.state
    const { visible, onClose, branches, items, action } = this.props

    return (
      <Modal open={visible} size="large" style={{ marginTop: 0 }}>
        <Header content="Add Item Unavailable" />
        <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="branch-form">
          <Form onSubmit={this.onSave} disabled={loading}>
            <BranchField
              value={selectedBranch}
              branches={branches}
              onChange={value => this.setState({ selectedBranch: value })}
              disabled={action === 'edit'}
            />

            <ItemField
              items={items}
              itemKeys={selectedItems}
              onChange={data => this.onItemsChange(data)}
            />

            {action === 'create' ? (
              <Form.Group widths="equal" style={{ marginLeft: 5, marginTop: 20 }}>
                <Checkbox
                  label="Apply to all branches"
                  checked={isApplyToAllBranches}
                  onChange={() => this.setState({ isApplyToAllBranches: !isApplyToAllBranches })}
                />
              </Form.Group>
            ) : null}

            <button
              type="submit"
              hidden
              ref={ref => { this.btnSubmitRef = ref }}
            />
          </Form>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={loading}
            disabled={loading}
          >
            <Icon name="checkmark" /> {action === 'create' ? 'Save' : 'Update'}
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default crossSellItemForm



// WEBPACK FOOTER //
// ./src/components/restaurants/forms/crossSellItemForm.js